<template>
  <div>
    <v-app-bar-nav-icon class="mobile-menu" variant="text" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    <v-navigation-drawer v-model="drawer" :mini-variant="miniVariant" class="drawer-mobile" app>
      <v-list dense>
        <v-list-item style="padding: 0 8px;">
          <v-list-item-avatar style="text-align: center;">
            <v-app-bar-nav-icon class="desktop-menu" @click.stop="miniVariant = !miniVariant"></v-app-bar-nav-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              <svg width="162" height="18" viewBox="0 0 162 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <!-- ... --></svg>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <!-- Без группы -->
        <v-list-item v-if="(access['order'] || access['*'] || 0) > 0" link :to="{name: 'order-index'}">
          <v-list-item-action>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M5.33301 19V6.72094C5.33301 6.16867 5.7807 5.72096 6.33297 5.72094L10.1968 5.72079C10.1968 4.77043 10.9673 4 11.9176 4H11.9748C12.9251 4 13.6956 4.77043 13.6956 5.72079L17.6664 5.72094C18.2186 5.72096 18.6663 6.16867 18.6663 6.72094V19C18.6663 19.5523 18.2186 20 17.6663 20H6.33301C5.78072 20 5.33301 19.5523 5.33301 19ZM6.66582 9.32344C6.66582 9.10252 6.84491 8.92344 7.06582 8.92344H16.9325C17.1534 8.92344 17.3325 9.10252 17.3325 9.32344C17.3325 9.54435 17.1534 9.72344 16.9325 9.72344H7.06582C6.84491 9.72344 6.66582 9.54435 6.66582 9.32344ZM7.06562 11.2379C6.84471 11.2379 6.66563 11.417 6.66563 11.6379C6.66563 11.8588 6.84471 12.0379 7.06563 12.0379H16.9323C17.1532 12.0379 17.3323 11.8588 17.3323 11.6379C17.3323 11.417 17.1532 11.2379 16.9323 11.2379H7.06562ZM6.66563 13.9504C6.66563 13.7295 6.84471 13.5504 7.06562 13.5504H11.599C11.8199 13.5504 11.999 13.7295 11.999 13.9504C11.999 14.1713 11.8199 14.3504 11.599 14.3504H7.06563C6.84471 14.3504 6.66563 14.1713 6.66563 13.9504ZM11.9633 6.64887C12.4542 6.64887 12.8522 6.2509 12.8522 5.75998C12.8522 5.26906 12.4542 4.87109 11.9633 4.87109C11.4724 4.87109 11.0744 5.26906 11.0744 5.75998C11.0744 6.2509 11.4724 6.64887 11.9633 6.64887Z"
                    fill="#5D6670"/>
            </svg>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Заказы</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="(access['order'] || access['*'] || 0) > 0" link :to="{name: 'utm-order-index'}">
          <v-list-item-action>
            <v-icon class="pl-1" small>mdi-chart-bar</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Маркетинг / UTM-заказы</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="(access['courier-map'] || access['*'] || 0) > 0" link :to="{name: 'courier-map'}">
          <v-list-item-action>
            <v-icon class="pl-1" small>mdi-map</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Карта с курьерами</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="(access['stops'] || access['*'] || 0) > 0" link :to="{name: 'stops'}">
          <v-list-item-action>
            <v-icon class="pl-1" small>mdi-stop</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Стопы</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="(access['stop-mods'] || access['*'] || 0) > 0" link :to="{name: 'stop-mods'}">
          <v-list-item-action>
            <v-icon class="pl-1" small>mdi-stop</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Стопы Модификаторы</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="(access['stop-glovo'] || access['*'] || 0) > 0" link :to="{name: 'stop-glovo'}">
          <v-list-item-action>
            <v-icon class="pl-1" small>mdi-stop-circle-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Стопы Glovo</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="(access['stop-mods-glovo'] || access['*'] || 0) > 0" link :to="{name: 'stop-mods-glovo'}">
          <v-list-item-action>
            <v-icon class="pl-1" small>mdi-stop-circle-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Стопы Glovo Модификаторы</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="(access['delivery'] || access['*'] || 0) > 0" link :to="{name: 'delivery-index'}">
          <v-list-item-action>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M18.8237 19.6667C18.4935 19.6667 18.1708 19.566 17.8964 19.3774C17.6219 19.1888 17.4079 18.9208 17.2816 18.6072C17.1553 18.2936 17.1222 17.9485 17.1866 17.6156C17.251 17.2827 17.41 16.9768 17.6434 16.7368C17.8769 16.4968 18.1743 16.3333 18.4981 16.2671C18.8218 16.2009 19.1574 16.2349 19.4624 16.3648C19.7674 16.4947 20.0281 16.7147 20.1115 16.9969C20.3949 17.2791 20.4928 17.611 20.4928 17.9504C20.4928 18.1758 20.4496 18.399 20.3657 18.6072C20.2819 18.8154 20.1589 19.0046 20.0039 19.164C19.8489 19.3234 19.6649 19.4498 19.4624 19.536C19.2599 19.6223 19.0429 19.6667 18.8237 19.6667ZM22.7929 12.372C22.9291 12.6521 23 12.9609 23 13.274V17.0281C23 17.2145 22.928 17.3933 22.7998 17.5251C22.6716 17.6569 22.4978 17.7309 22.3165 17.7309H21.3619C21.3089 17.0762 21.0185 16.4659 20.5484 16.021C20.0782 15.5762 19.4626 15.3293 18.8237 15.3293C18.1847 15.3293 17.5692 15.5762 17.099 16.021C16.6288 16.4659 16.3385 17.0762 16.2855 17.7309H9.91619C9.86318 17.0762 9.57279 16.4659 9.10263 16.021C8.63246 15.5762 8.01687 15.3293 7.37793 15.3293C6.739 15.3293 6.1234 15.5762 5.65324 16.021C5.18308 16.4659 4.89269 17.0762 4.83967 17.7309H4.47128C4.38151 17.7309 4.29262 17.7128 4.20969 17.6774C4.12675 17.6421 4.0514 17.5903 3.98792 17.5251C3.92445 17.4598 3.8741 17.3823 3.83975 17.297C3.8054 17.2118 3.78772 17.1204 3.78772 17.0281V13.7157H7.0722C7.15777 13.7157 7.24238 13.6973 7.32057 13.6615C7.39875 13.6258 7.46876 13.5735 7.52607 13.5082C7.58338 13.4429 7.6267 13.3659 7.65325 13.2822C7.67979 13.1986 7.68895 13.1102 7.68015 13.0226C7.65888 12.864 7.58165 12.7189 7.46314 12.615C7.34464 12.5111 7.19312 12.4556 7.03741 12.459H1.73333C1.53884 12.459 1.35232 12.3796 1.21479 12.2382C1.07726 12.0967 1 11.9049 1 11.705C1 11.505 1.07726 11.3132 1.21479 11.1718C1.35232 11.0304 1.53884 10.9509 1.73333 10.9509H8.29442C8.37999 10.9509 8.4646 10.9324 8.54279 10.8967C8.62097 10.8609 8.69098 10.8087 8.74829 10.7434C8.8056 10.678 8.84893 10.6011 8.87547 10.5174C8.90201 10.4338 8.91118 10.3453 8.90237 10.2578C8.8811 10.0992 8.80387 9.95408 8.68536 9.85016C8.56686 9.74625 8.41534 9.69073 8.25963 9.69418H3.29883C3.10434 9.69418 2.91781 9.61473 2.78028 9.47332C2.64276 9.33191 2.5655 9.14012 2.5655 8.94013C2.5655 8.74015 2.64276 8.54835 2.78028 8.40694C2.91781 8.26553 3.10434 8.18609 3.29883 8.18609H9.51665C9.60221 8.18609 9.68683 8.16762 9.76501 8.13187C9.84319 8.09611 9.91321 8.04388 9.97051 7.97854C10.0278 7.91321 10.0711 7.83623 10.0977 7.75258C10.1242 7.66894 10.1334 7.5805 10.1246 7.49298C10.1033 7.33433 10.0261 7.18925 9.90759 7.08534C9.78908 6.98142 9.63757 6.9259 9.48185 6.92935H3.78772V5.97612C3.78772 5.84793 3.81227 5.721 3.85998 5.60257C3.90769 5.48414 3.97761 5.37654 4.06576 5.2859C4.15392 5.19525 4.25857 5.12336 4.37374 5.0743C4.48892 5.02525 4.61236 5 4.73703 5H16.287C16.4117 5 16.5351 5.02525 16.6503 5.0743C16.7655 5.12336 16.8701 5.19526 16.9583 5.2859C17.0464 5.37654 17.1163 5.48415 17.164 5.60258C17.2118 5.72101 17.2363 5.84794 17.2363 5.97612V8.95096H20.8657C20.9449 8.95096 21.0226 8.97364 21.09 9.01646C21.1574 9.05928 21.2118 9.12056 21.2472 9.19341L22.7929 12.372ZM22.1461 13.0055L20.6014 9.82895H17.2363V13.2615H22.1461L22.1461 13.0055ZM9.04718 17.9504C9.04718 17.611 8.94929 17.2792 8.76589 16.9969C8.58249 16.7147 8.32181 16.4947 8.01682 16.3648C7.71183 16.2349 7.37623 16.2009 7.05245 16.2671C6.72868 16.3334 6.43127 16.4968 6.19784 16.7368C5.96441 16.9768 5.80544 17.2827 5.74103 17.6156C5.67662 17.9485 5.70967 18.2936 5.836 18.6072C5.96233 18.9208 6.17626 19.1888 6.45074 19.3774C6.72522 19.566 7.04793 19.6667 7.37804 19.6667C7.59724 19.6667 7.81428 19.6223 8.01679 19.536C8.2193 19.4498 8.40331 19.3234 8.5583 19.164C8.71329 19.0046 8.83624 18.8154 8.92013 18.6072C9.00401 18.399 9.04718 18.1758 9.04718 17.9504Z"
                  fill="#5D6670"/>
            </svg>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Доставка</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="(access['delivery'] || access['*'] || 0) > 0" link :to="{name: 'bad-delivery-condition-index'}">
          <v-list-item-action>
            <v-icon class="pl-1" small>mdi-weather-pouring</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Погодные условия</v-list-item-title>
          </v-list-item-content>
        </v-list-item>


        <!-- ===== МЕНЮ ===== -->
        <v-divider></v-divider>
        <v-list-group :value="false" prepend-icon="mdi-silverware-fork-knife">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Меню</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item v-if="(access['category'] || access['*'] || 0) > 0" link :to="{name: 'category-index'}">
            <v-list-item-action>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="7.36523" y="7" width="12.635" height="1.88753" rx="0.943764" fill="#5D6670"/>
                <ellipse cx="5.00852" cy="7.94376" rx="1.00852" ry="0.943764" fill="#5D6670"/>
                <rect x="7.36523" y="12.0547" width="12.635" height="1.88753" rx="0.943764" fill="#5D6670"/>
                <ellipse cx="5.00852" cy="12.9985" rx="1.00852" ry="0.943764" fill="#5D6670"/>
                <rect x="7.36523" y="17.1133" width="12.635" height="1.88753" rx="0.943764" fill="#5D6670"/>
                <ellipse cx="5.00852" cy="18.057" rx="1.00852" ry="0.943764" fill="#5D6670"/>
              </svg>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Категории</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="(access['product'] || access['*'] || 0) > 0" link :to="{name: 'product-index'}">
            <v-list-item-action>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M7.72947 13.1165L7.3732 13.4657L7.01577 13.817C7.01495 13.8161 7.01413 13.8153 7.01331 13.8145L7.72763 13.1147C7.72824 13.1153 7.72886 13.1159 7.72947 13.1165ZM7.72947 13.1165L18.0239 3.02634C18.0989 2.95868 18.2186 3.01192 18.2186 3.11293V20.031C18.2186 20.593 17.7551 21.0474 17.1949 21.0027C13.1678 20.6816 9.25218 19.0578 6.0823 16.1315C5.67741 15.7578 5.68562 15.1241 6.07864 14.7379L7.01577 13.817C8.47637 15.307 10.452 16.5542 12.4577 17.4293C14.4609 18.3034 16.5391 18.8257 18.2149 18.8257V17.8257C16.7198 17.8257 14.7812 17.3521 12.8576 16.5128C10.9385 15.6755 9.07931 14.4937 7.72947 13.1165Z"
                      fill="#5D6670"/>
                <path
                    d="M12.026 13.6343C12.3591 13.6343 12.6292 13.3577 12.6292 13.0164C12.6292 12.6751 12.3591 12.3984 12.026 12.3984C11.6929 12.3984 11.4229 12.6751 11.4229 13.0164C11.4229 13.3577 11.6929 13.6343 12.026 13.6343Z"
                    fill="white"/>
                <path
                    d="M15.8863 13.0132C16.2195 13.0132 16.4895 12.7366 16.4895 12.3953C16.4895 12.054 16.2195 11.7773 15.8863 11.7773C15.5532 11.7773 15.2832 12.054 15.2832 12.3953C15.2832 12.7366 15.5532 13.0132 15.8863 13.0132Z"
                    fill="white"/>
                <path
                    d="M15.5905 9.13042C15.9236 9.13042 16.1936 8.85375 16.1936 8.51247C16.1936 8.17119 15.9236 7.89453 15.5905 7.89453C15.2573 7.89453 14.9873 8.17119 14.9873 8.51247C14.9873 8.85375 15.2573 9.13042 15.5905 9.13042Z"
                    fill="white"/>
              </svg>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Блюда</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="(access['modifiers-group'] || access['*'] || 0) > 0" link
                       :to="{name: 'modifiers-group-index'}">
            <v-list-item-action>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 7.55917C13.4303 7.55917 14.5894 8.71789 14.5941 10.1485H19.2211C19.6513 10.1485 20 9.79979 20 9.36961C20 8.93943 19.6513 8.5907 19.2211 8.5907H17.5022C17.3803 8.16053 17.2119 7.75068 16.9986 7.36817L18.0572 6.30834C18.4472 5.9179 18.4472 5.28533 18.0572 4.89489L17.2579 4.09477C16.8673 3.70374 16.2335 3.70375 15.8429 4.09478L14.7858 5.15305C14.4037 4.93946 13.9942 4.7709 13.5646 4.64883V3.14844C13.5646 2.59615 13.1169 2.14844 12.5646 2.14844H11.4354C10.8831 2.14844 10.4354 2.59615 10.4354 3.14844V4.64883C10.0057 4.7709 9.59629 4.93946 9.21416 5.15305L8.15697 4.09475C7.76636 3.70373 7.13261 3.70373 6.74201 4.09476L5.94274 4.89488C5.55272 5.28532 5.55272 5.9179 5.94274 6.30834L7.00144 7.36817C6.78805 7.75068 6.61967 8.16056 6.49772 8.5907H4.77891C4.34873 8.5907 4 8.93943 4 9.36961C4 9.79979 4.34873 10.1485 4.77891 10.1485H9.40587C9.41048 8.71789 10.5697 7.55917 12 7.55917Z"
                    fill="#5D6670"/>
                <path
                    d="M4 12.8342C4 12.42 4.33577 12.0842 4.74997 12.0842H19.2498C19.664 12.0842 19.9997 12.42 19.9997 12.8342C19.9997 13.2484 19.664 13.5841 19.2498 13.5841H4.74997C4.33577 13.5841 4 13.2484 4 12.8342Z"
                    fill="#5D6670"/>
                <path
                    d="M4 16.4522C4 16.038 4.33577 15.7023 4.74997 15.7023H19.2498C19.664 15.7023 19.9997 16.038 19.9997 16.4522C19.9997 16.8664 19.664 17.2022 19.2498 17.2022H4.74997C4.33577 17.2022 4 16.8664 4 16.4522Z"
                    fill="#5D6670"/>
                <path
                    d="M4 20.0703C4 19.6561 4.33577 19.3203 4.74997 19.3203H19.2498C19.664 19.3203 19.9997 19.6561 19.9997 20.0703C19.9997 20.4845 19.664 20.8203 19.2498 20.8203H4.74997C4.33577 20.8203 4 20.4845 4 20.0703Z"
                    fill="#5D6670"/>
                <path
                    d="M10.6293 11.5009C10.6293 11.2554 10.8283 11.0564 11.0738 11.0564C11.3192 11.0564 11.5182 11.2554 11.5182 11.5009V14.1675C11.5182 14.413 11.3192 14.612 11.0738 14.612C10.8283 14.612 10.6293 14.413 10.6293 14.1675V11.5009Z"
                    fill="#5D6670"/>
                <path
                    d="M15.1128 15.1189C15.1128 14.8735 15.3118 14.6745 15.5573 14.6745C15.8028 14.6745 16.0017 14.8735 16.0017 15.1189V17.7856C16.0017 18.0311 15.8028 18.23 15.5573 18.23C15.3118 18.23 15.1128 18.0311 15.1128 17.7856V15.1189Z"
                    fill="#5D6670"/>
                <path
                    d="M7.18403 18.737C7.18403 18.4915 7.38301 18.2925 7.62847 18.2925C7.87393 18.2925 8.07292 18.4915 8.07292 18.737V21.4036C8.07292 21.6491 7.87393 21.8481 7.62847 21.8481C7.38301 21.8481 7.18403 21.6491 7.18403 21.4036V18.737Z"
                    fill="#5D6670"/>
              </svg>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Модификаторы</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="(access['modifier'] || access['*'] || 0) > 0" link :to="{name: 'modifier-index'}">
            <v-list-item-action>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.3526 8.17319L13.8588 7.40229C14.8633 6.88812 16.0944 7.29196 16.5993 8.30126C16.8651 8.83272 16.8847 9.45398 16.6529 10.0011L16.0098 11.5194C15.7941 12.0287 15.4751 12.4876 15.0731 12.8673L8.08772 19.4645C7.27555 20.2315 6.00803 19.2918 6.50591 18.2918L10.7235 9.8206C11.0765 9.11147 11.6475 8.53411 12.3526 8.17319Z"
                    fill="#5D6670"/>
                <path
                    d="M14.1541 4.88382L14.749 7.58168H15.783L16.1119 4.78591C16.1815 4.19499 15.7197 3.67578 15.1248 3.67578C14.4895 3.67578 14.0173 4.26348 14.1541 4.88382Z"
                    fill="#5D6670"/>
                <path
                    d="M16.6496 5.0235L15.178 7.36158L15.9139 8.08789L18.1119 6.32908C18.5764 5.95734 18.6125 5.26347 18.1891 4.84553C17.7369 4.39931 16.988 4.48589 16.6496 5.0235Z"
                    fill="#5D6670"/>
                <path
                    d="M18.7929 6.66874L16.0951 7.26367L16.0951 8.29764L18.8908 8.62658C19.4818 8.6961 20.001 8.2344 20.001 7.6394C20.001 7.00416 19.4133 6.53194 18.7929 6.66874Z"
                    fill="#5D6670"/>
              </svg>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Ингредиенты</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="(access['modifier-categories'] || access['*'] || 0) > 0" link
                       :to="{name: 'modifier-category-index'}">
            <v-list-item-action>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.3526 8.17319L13.8588 7.40229C14.8633 6.88812 16.0944 7.29196 16.5993 8.30126C16.8651 8.83272 16.8847 9.45398 16.6529 10.0011L16.0098 11.5194C15.7941 12.0287 15.4751 12.4876 15.0731 12.8673L8.08772 19.4645C7.27555 20.2315 6.00803 19.2918 6.50591 18.2918L10.7235 9.8206C11.0765 9.11147 11.6475 8.53411 12.3526 8.17319Z"
                    fill="#5D6670"/>
                <path
                    d="M14.1541 4.88382L14.749 7.58168H15.783L16.1119 4.78591C16.1815 4.19499 15.7197 3.67578 15.1248 3.67578C14.4895 3.67578 14.0173 4.26348 14.1541 4.88382Z"
                    fill="#5D6670"/>
                <path
                    d="M16.6496 5.0235L15.178 7.36158L15.9139 8.08789L18.1119 6.32908C18.5764 5.95734 18.6125 5.26347 18.1891 4.84553C17.7369 4.39931 16.988 4.48589 16.6496 5.0235Z"
                    fill="#5D6670"/>
                <path
                    d="M18.7929 6.66874L16.0951 7.26367L16.0951 8.29764L18.8908 8.62658C19.4818 8.6961 20.001 8.2344 20.001 7.6394C20.001 7.00416 19.4133 6.53194 18.7929 6.66874Z"
                    fill="#5D6670"/>
              </svg>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Категории ингредиентов</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="(access['sets'] || access['*'] || 0) > 0" link :to="{name: 'combo-product-index'}">
            <v-list-item-action>
              <v-icon class="pl-1" small>mdi-video-input-svideo</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Сеты</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="(access['tags'] || access['*'] || 0) > 0" link :to="{name: 'tag-index'}">
            <v-list-item-action>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="9.62891" y="4" width="1.65408" height="15.5516" rx="0.82704"
                      transform="rotate(11.1565 9.62891 4)" fill="#5D6670"/>
                <rect x="19.7754" y="8.51172" width="1.65408" height="15.5516" rx="0.82704"
                      transform="rotate(90 19.7754 8.51172)" fill="#5D6670"/>
                <rect x="19.7754" y="13.832" width="1.65408" height="15.5516" rx="0.82704"
                      transform="rotate(90 19.7754 13.832)" fill="#5D6670"/>
                <rect x="15.7578" y="4.42188" width="1.65408" height="15.5516" rx="0.82704"
                      transform="rotate(11.1565 15.7578 4.42188)" fill="#5D6670"/>
              </svg>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Теги</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="(access['collection'] || access['*'] || 0) > 0" link :to="{name: 'collection-index'}">
            <v-list-item-action>
              <v-icon class="pl-1" small>mdi-view-grid</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Подборки</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="(access['block'] || access['*'] || 0) > 0" link :to="{name: 'block-index'}">
            <v-list-item-action>
              <v-icon class="pl-1" small>mdi-playlist-check</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Блоки</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <!-- ===== КОНТЕНТ ===== -->
        <v-divider></v-divider>
        <v-list-group :value="false" prepend-icon="mdi-newspaper-variant-outline">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Контент</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item v-if="(access['home'] || access['*'] || 0) > 0" link :to="{name: 'home-index'}">
            <v-list-item-action>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12.429 5.26399C12.1659 5.1021 11.8341 5.1021 11.571 5.26399L5.38954 9.06798C5.14746 9.21695 5 9.48084 5 9.76508V18.1815C5 18.6335 5.36646 19 5.81852 19H9.02764C9.47969 19 9.84615 18.6335 9.84615 18.1815V15.5108C9.84615 15.0588 10.2126 14.6923 10.6647 14.6923H13.3353C13.7874 14.6923 14.1538 15.0588 14.1538 15.5108V18.1815C14.1538 18.6335 14.5203 19 14.9724 19H18.1815C18.6335 19 19 18.6335 19 18.1815V9.76508C19 9.48084 18.8525 9.21695 18.6105 9.06798L12.429 5.26399Z"
                    fill="#5D6670"/>
              </svg>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Главная страница</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="(access['sale'] || access['*'] || 0) > 0" link :to="{name: 'sale-index'}">
            <v-list-item-action>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M11.9043 16.945L7.98138 19.8327C7.3116 20.3306 6.45041 19.6336 6.73746 18.837L8.1727 14.0573L4.3454 11.07C3.67562 10.5721 4.05835 9.57628 4.82381 9.4767L9.60794 9.37715L11.2346 4.59746C11.5217 3.80085 12.5741 3.80085 12.7655 4.59746L14.3921 9.37715L19.1762 9.4767C19.9417 9.4767 20.3244 10.5721 19.6546 11.07L15.8273 14.0573L17.2625 18.837C17.4539 19.6336 16.6885 20.231 16.0187 19.8327L11.9043 16.945Z"
                    fill="#5D6670"/>
              </svg>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Акции</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="(access['banner'] || access['*'] || 0) > 0" link :to="{name: 'banner-index'}">
            <v-list-item-action>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M6 5C6 4.44771 6.44772 4 7 4H17C17.5523 4 18 4.44772 18 5V14C18 14.5523 17.5523 15 17 15H7C6.44772 15 6 14.5523 6 14V5Z"
                    fill="#5D6670"/>
                <rect x="6" y="16" width="12" height="4" rx="1" fill="#5D6670"/>
              </svg>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Баннеры</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="(access['job'] || access['*'] || 0) > 0" link :to="{name: 'job-index'}">
            <v-list-item-action>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.5814 17.9481L6.6814 10.7481C6.53219 9.55436 7.46296 8.5 8.66596 8.5H15.6136C16.8413 8.5 17.7792 9.5958 17.5896 10.8088L16.4646 18.0088C16.3125 18.9823 15.474 19.7 14.4886 19.7H9.56595C8.55731 19.7 7.70651 18.9489 7.5814 17.9481Z"
                    fill="#5D6670"/>
                <path d="M12 15V16.75" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9.19922 16.1855L9.64132 17.8788" stroke="white" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M14.8242 16.1855L14.3821 17.8788" stroke="white" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <circle cx="12" cy="8.5" r="3.5" fill="#5D6670"/>
                <circle cx="7.8" cy="10.6008" r="2.8" fill="#5D6670"/>
                <circle cx="16.2004" cy="10.6008" r="2.8" fill="#5D6670"/>
              </svg>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Вакансии</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="(access['news'] || access['*'] || 0) > 0" link :to="{name: 'news-index'}">
            <v-list-item-action>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.5 16H17.5" stroke="#5D6670" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M6.5 18.5H17.5" stroke="#5D6670" stroke-linecap="round" stroke-linejoin="round"/>
                <path
                    d="M6 7C6 6.44772 6.44772 6 7 6H17C17.5523 6 18 6.44772 18 7V13C18 13.5523 17.5523 14 17 14H7C6.44772 14 6 13.5523 6 13V7Z"
                    fill="#5D6670"/>
              </svg>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Новости</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="(access['contact'] || access['*'] || 0) > 0" link :to="{name: 'contact-index'}">
            <v-list-item-action>
              <svg width="24" height="24" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7 6C6.44772 6 6 6.44772 6 7V19C6 19.5523 6.44772 20 7 20H17C17.5523 20 18 19.5523 18 19V7C18 6.44772 17.5523 6 17 6H7ZM9.15374 9.50028C8.8776 9.50028 8.65374 9.72414 8.65374 10.0003C8.65374 10.2764 8.8776 10.5003 9.15374 10.5003H15.1537C15.4299 10.5003 15.6537 10.2764 15.6537 10.0003C15.6537 9.72414 15.4299 9.50028 15.1537 9.50028H9.15374ZM8.65374 13.0003C8.65374 12.7241 8.8776 12.5003 9.15374 12.5003H15.1537C15.4299 12.5003 15.6537 12.7241 15.6537 13.0003C15.6537 13.2764 15.4299 13.5003 15.1537 13.5003H9.15374C8.8776 13.5003 8.65374 13.2764 8.65374 13.0003ZM9.15374 15.5003C8.8776 15.5003 8.65374 15.7241 8.65374 16.0003C8.65374 16.2764 8.8776 16.5003 9.15374 16.5003H15.1537C15.4299 16.5003 15.6537 16.2764 15.6537 16.0003C15.6537 15.7241 15.4299 15.5003 15.1537 15.5003H9.15374Z" fill="#5D6670"/>
              </svg>

            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Контакты</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="(access['info'] || access['*'] || 0) > 0" link :to="{name: 'info-index'}">
            <v-list-item-action>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="10" y="10" width="4" height="9" rx="1" fill="#5D6670"/>
                <rect x="10" y="5" width="4" height="4" rx="1" fill="#5D6670"/>
              </svg>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>О нас</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="(access['partnership'] || access['*'] || 0) > 0" link :to="{name: 'partnership-index'}">
            <v-list-item-action>
              <svg width="24" height="24" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M7 6C6.44772 6 6 6.44772 6 7V19C6 19.5523 6.44772 20 7 20H17C17.5523 20 18 19.5523 18 19V7C18 6.44772 17.5523 6 17 6H7ZM9.15374 9.50028C8.8776 9.50028 8.65374 9.72414 8.65374 10.0003C8.65374 10.2764 8.8776 10.5003 9.15374 10.5003H15.1537C15.4299 10.5003 15.6537 10.2764 15.6537 10.0003C15.6537 9.72414 15.4299 9.50028 15.1537 9.50028H9.15374ZM8.65374 13.0003C8.65374 12.7241 8.8776 12.5003 9.15374 12.5003H15.1537C15.4299 12.5003 15.6537 12.7241 15.6537 13.0003C15.6537 13.2764 15.4299 13.5003 15.1537 13.5003H9.15374C8.8776 13.5003 8.65374 13.2764 8.65374 13.0003ZM9.15374 15.5003C8.8776 15.5003 8.65374 15.7241 8.65374 16.0003C8.65374 16.2764 8.8776 16.5003 9.15374 16.5003H15.1537C15.4299 16.5003 15.6537 16.2764 15.6537 16.0003C15.6537 15.7241 15.4299 15.5003 15.1537 15.5003H9.15374Z"
                      fill="#5D6670"/>
              </svg>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Сотрудничество</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="(access['payment-delivery'] || access['*'] || 0) > 0" link
                       :to="{name: 'payment-delivery-index'}">
            <v-list-item-action>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="10" y="10" width="4" height="9" rx="1" fill="#5D6670"/>
                <rect x="10" y="5" width="4" height="4" rx="1" fill="#5D6670"/>
              </svg>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Оплата и Доставка</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <!-- ===== СЕО ===== -->
        <v-divider></v-divider>
        <v-list-group :value="false" prepend-icon="mdi-magnify">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>СЕО</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item v-if="(access['landing-page'] || access['*'] || 0) > 0" link :to="{name: 'landing-page-index'}">
            <v-list-item-action>
              <svg width="24" height="24" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M7 6C6.44772 6 6 6.44772 6 7V19C6 19.5523 6.44772 20 7 20H17C17.5523 20 18 19.5523 18 19V7C18 6.44772 17.5523 6 17 6H7ZM9.15374 9.50028C8.8776 9.50028 8.65374 9.72414 8.65374 10.0003C8.65374 10.2764 8.8776 10.5003 9.15374 10.5003H15.1537C15.4299 10.5003 15.6537 10.2764 15.6537 10.0003C15.6537 9.72414 15.4299 9.50028 15.1537 9.50028H9.15374ZM8.65374 13.0003C8.65374 12.7241 8.8776 12.5003 9.15374 12.5003H15.1537C15.4299 12.5003 15.6537 12.7241 15.6537 13.0003C15.6537 13.2764 15.4299 13.5003 15.1537 13.5003H9.15374C8.8776 13.5003 8.65374 13.2764 8.65374 13.0003ZM9.15374 15.5003C8.8776 15.5003 8.65374 15.7241 8.65374 16.0003C8.65374 16.2764 8.8776 16.5003 9.15374 16.5003H15.1537C15.4299 16.5003 15.6537 16.2764 15.6537 16.0003C15.6537 15.7241 15.4299 15.5003 15.1537 15.5003H9.15374Z"
                      fill="#5D6670"/>
              </svg>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Посадочные страницы</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="(access['tag-landing'] || access['*'] || 0) > 0" link :to="{name: 'tag-landing-index'}">
            <v-list-item-action>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="9.62891" y="4" width="1.65408" height="15.5516" rx="0.82704"
                      transform="rotate(11.1565 9.62891 4)" fill="#5D6670"/>
                <rect x="19.7754" y="8.51172" width="1.65408" height="15.5516" rx="0.82704"
                      transform="rotate(90 19.7754 8.51172)" fill="#5D6670"/>
                <rect x="19.7754" y="13.832" width="1.65408" height="15.5516" rx="0.82704"
                      transform="rotate(90 19.7754 13.832)" fill="#5D6670"/>
                <rect x="15.7578" y="4.42188" width="1.65408" height="15.5516" rx="0.82704"
                      transform="rotate(11.1565 15.7578 4.42188)" fill="#5D6670"/>
              </svg>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Посадочные страницы (теги)</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="(access['article'] || access['*'] || 0) > 0" link :to="{name: 'article-index'}">
            <v-list-item-action>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.5 16H17.5" stroke="#5D6670" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M6.5 18.5H17.5" stroke="#5D6670" stroke-linecap="round" stroke-linejoin="round"/>
                <path
                    d="M6 7C6 6.44772 6.44772 6 7 6H17C17.5523 6 18 6.44772 18 7V13C18 13.5523 17.5523 14 17 14H7C6.44772 14 6 13.5523 6 13V7Z"
                    fill="#5D6670"/>
              </svg>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Статьи</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <!-- ===== Без группы (остальное) ===== -->
        <v-divider></v-divider>

        <v-list-item v-if="(access['change-price'] || access['*'] || 0) > 0" link :to="{name: 'change-price-index'}">
          <v-list-item-action>
            <v-icon class="pl-1" small>mdi-chart-line-variant</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Изменение цен</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="(access['courier-index'] || access['*'] || 0) > 0" link :to="{name: 'courier-index'}">
          <v-list-item-action>
            <v-icon class="pl-1" small>mdi-moped</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Курьеры</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="(access['constructor'] || access['*'] || 0) > 0" link :to="{name: 'constructor-index'}">
          <v-list-item-action>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M15.5 7.22359C15.7761 6.74529 16.3925 6.5767 16.8326 6.91032C17.9712 7.77338 18.8631 8.92983 19.4073 10.264C20.0781 11.9082 20.1827 13.7288 19.7048 15.4391C19.2268 17.1493 18.1934 18.6519 16.7674 19.7101C15.3413 20.7683 13.6038 21.322 11.8284 21.2839C10.0531 21.2458 8.34082 20.6181 6.9615 19.4997C5.58218 18.3813 4.61417 16.8358 4.20999 15.1066C3.8058 13.3775 3.98842 11.563 4.72907 9.94907C5.33005 8.63949 6.27072 7.52236 7.4453 6.70892C7.89934 6.39449 8.50785 6.58936 8.76322 7.07906L11.5789 12.4784C11.7614 12.8282 12.258 12.8388 12.4553 12.4972L15.5 7.22359Z"
                  fill="#5D6670"/>
              <path
                  d="M12.4832 10.5287L15.8142 4.50109C15.9293 4.29273 15.8831 4.02915 15.6876 3.89326C14.4027 3 12.8983 3 12.1074 3C11.3118 3 10.4263 3.00114 8.93597 3.90955C8.72374 4.03891 8.64953 4.30944 8.75626 4.5339L11.594 10.5015C11.7688 10.8692 12.2862 10.885 12.4832 10.5287Z"
                  fill="#5D6670"/>
            </svg>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Конструктор</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="(access['user'] || access['*'] || 0) > 0" link :to="{name: 'user-index'}">
          <v-list-item-action>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12.0005" cy="6.99854" r="2.99854" fill="#5D6670"/>
              <path
                  d="M8.50241 12.7321L9.53333 12.1376C9.68524 12.05 9.85751 12.0039 10.0329 12.0039H13.8887C14.1129 12.0039 14.3306 12.0793 14.5068 12.2179L15.6162 13.0903C15.8573 13.2799 15.998 13.5696 15.998 13.8763V19C15.998 19.5523 15.5503 20 14.998 20H9.00195C8.44967 20 8.00195 19.5523 8.00195 19V13.5984C8.00195 13.2409 8.19275 12.9106 8.50241 12.7321Z"
                  fill="#5D6670" stroke="#5D6670"/>
            </svg>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Клиенты</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="(access['bonus-block'] || access['*'] || 0) > 0" link :to="{name: 'reserved-bonus-index'}">
          <v-list-item-action>
            <v-icon class="pl-1" small>mdi-cancel</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Бонусы (блок)</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="(access['promocode'] || access['*'] || 0) > 0" link :to="{name: 'promocode-index'}">
          <v-list-item-action>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M5.76855 21V11.5312H18.231V21C18.231 21.5523 17.7832 22 17.231 22H6.76855C6.21627 22 5.76855 21.5523 5.76855 21ZM10.3046 18.9446L11.9595 17.7264L13.6952 18.9446C13.9777 19.1127 14.3006 18.8606 14.2199 18.5246L13.6144 16.5083L15.229 15.248C15.5115 15.038 15.35 14.5759 15.0271 14.5759L13.0089 14.5339L12.3228 12.5176C12.242 12.1815 11.798 12.1815 11.677 12.5176L10.9907 14.5339L8.97254 14.5759C8.64963 14.6179 8.48817 15.038 8.77072 15.248L10.3853 16.5083L9.77982 18.5246C9.65873 18.8606 10.022 19.1547 10.3046 18.9446Z"
                    fill="#5D6670"/>
              <path
                  d="M4.21973 10.5299V9.82812C4.21973 9.27584 4.66744 8.82812 5.21973 8.82812H18.7807C19.333 8.82812 19.7807 9.27584 19.7807 9.82812V10.5299C19.7807 11.0822 19.333 11.5299 18.7807 11.5299H5.21973C4.66744 11.5299 4.21973 11.0822 4.21973 10.5299Z"
                  fill="#5D6670"/>
              <path
                  d="M11.3896 5.04737V8.82749H12.8047V5.04737C12.8047 4.65662 12.4879 4.33984 12.0972 4.33984C11.7064 4.33984 11.3896 4.65662 11.3896 5.04737Z"
                  fill="#5D6670"/>
              <path
                  d="M8.15706 6.83601L11.3896 8.39005L9.47538 5.35688C9.07478 4.72211 8.15175 4.71466 7.74096 5.34289C7.40015 5.8641 7.5958 6.56618 8.15706 6.83601Z"
                  stroke="#5D6670"/>
              <path
                  d="M16.0363 6.83601L12.8038 8.39005L14.718 5.35688C15.1186 4.72211 16.0416 4.71466 16.4524 5.34289C16.7932 5.8641 16.5976 6.56618 16.0363 6.83601Z"
                  stroke="#5D6670"/>
            </svg>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Промокоды</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="(access['review'] || access['*'] || 0) > 0" link :to="{name: 'review-index'}">
          <v-list-item-action>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M18.8813 10.7349H14.2698L14.6545 10.2079C15.3818 9.22234 15.7718 8.01546 15.7718 6.77695V5.34345C15.7718 3.85753 13.7901 3.49016 13.2632 4.8217L12.5886 6.4818C12.1386 7.60249 11.3653 8.54555 10.3854 9.19428L8.61125 10.4292C8.54401 10.4761 8.50391 10.5528 8.50391 10.6348V18.8249C8.50391 18.9381 8.57979 19.0371 8.68906 19.0666L10.9759 19.6838C11.7875 19.8946 12.6202 20 13.4582 20H17.1368C17.7664 20 18.2594 19.4709 18.2594 18.8405C18.2594 18.2028 17.7534 17.6811 17.1368 17.6811H17.7587C18.3929 17.6811 18.876 17.1496 18.876 16.5269C18.876 15.8839 18.3753 15.3674 17.7587 15.3674H18.3806C18.9939 15.3674 19.4979 14.8457 19.4979 14.208C19.4979 13.5703 18.9972 13.0485 18.3806 13.0485H18.8812C19.4962 13.0485 20.0038 12.5397 20.0038 11.8891C20.0038 11.2514 19.5032 10.7349 18.8813 10.7349Z"
                  fill="#5D6670"/>
              <path
                  d="M7.25192 10.4883H6.00006C4.89382 10.4883 3.99707 11.3851 3.99707 12.4913C3.99707 13.5975 3.99707 15.9156 3.99707 17.0219C3.99707 18.1281 4.89382 19.0248 6.00006 19.0248H7.25192C7.39019 19.0248 7.5023 18.9127 7.5023 18.7745V10.7387C7.5023 10.6004 7.39019 10.4883 7.25192 10.4883Z"
                  fill="#5D6670"/>
            </svg>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Отзывы</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="(access['app-log'] || access['*'] || 0) > 0" link :to="{name: 'app-log-index'}">
          <v-list-item-action>
            <v-icon class="pl-1" small>mdi-text-box-search-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Логи приложения</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-group  v-if="(access['push'] || access['*'] || 0) > 0" :value="false" prepend-icon="mdi-bell">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Уведомления</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item v-if="(access['push'] || access['*'] || 0) > 0" link :to="{name: 'push-index'}">
            <v-list-item-action>
              <v-icon class="pl-1" small>mdi-bell</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Рассылка уведомлений</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="(access['push'] || access['*'] || 0) > 0" link :to="{name: 'push-bonus-index'}">
            <v-list-item-action>
              <v-icon class="pl-1" small>mdi-bell</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Уведомления про бонусы</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="(access['push'] || access['*'] || 0) > 0" link :to="{name: 'push-new-client-index'}">
            <v-list-item-action>
              <v-icon class="pl-1" small>mdi-bell</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Уведомления про нового клиента</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-item v-if="(access['pay-invoices'] || access['*'] || 0) > 0" link :to="{name: 'pay-invoices'}">
          <v-list-item-action>
            <v-icon class="pl-1" small>mdi-cash-clock</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Оплаты</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="(access['sms-log'] || access['*'] || 0) > 0" link :to="{name: 'sms-log-index'}">
          <v-list-item-action>
            <v-icon class="pl-1" small>mdi-post</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Логи СМС</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="(access['push-log'] || access['*'] || 0) > 0" link :to="{name: 'push-log'}">
          <v-list-item-action>
            <v-icon class="pl-1" small>mdi-math-log</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Лог уведомлений</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="(access['setting'] || access['*'] || 0) > 0" link :to="{name: 'setting-index'}">
          <v-list-item-action>
            <v-icon class="pl-1" small>mdi-cog</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Настройки</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="(access['online-pay-account'] || access['*'] || 0) > 0" link
                     :to="{name: 'online-pay-account-index'}">
          <v-list-item-action>
            <v-icon class="pl-1" small>mdi-account-cash</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Аккаунты онлайн оплаты</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="(access['checkbox-login'] || access['*'] || 0) > 0" link
                     :to="{name: 'checkbox-login-index'}">
          <v-list-item-action>
            <v-icon class="pl-1" small>mdi-cash-register</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Checkbox аккаунты</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="(access['offer-page-index'] || access['*'] || 0) > 0" link :to="{name: 'offer-page-index'}">
          <v-list-item-action>
            <v-icon class="pl-1" small>mdi-text-account</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Договоры оферты</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="(access['franchise-page-index'] || access['*'] || 0) > 0" link :to="{name: 'franchise-page-index'}">
          <v-list-item-action>
            <v-icon class="pl-1" small>mdi-storefront</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Договоры франчайзи</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="(access['role'] || access['*'] || 0) > 0" link :to="{name: 'role'}">
          <v-list-item-action>
            <v-icon class="pl-1" small>mdi-file-account</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Роли</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="(access['session'] || access['*'] || 0) > 0" link :to="{name: 'session'}">
          <v-list-item-action>
            <v-icon class="pl-1" small>mdi-format-list-checkbox</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Сессии</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="(access['user'] || access['*'] || 0) > 0" link :to="{name: 'reports-index'}">
          <v-list-item-action><v-icon class="pl-1" small>mdi-file-chart-outline</v-icon></v-list-item-action>
          <v-list-item-content><v-list-item-title>Отчёты</v-list-item-title></v-list-item-content>
        </v-list-item>

        <v-list-item @click="logout()">
          <v-list-item-action>
            <v-icon class="pl-1" small>mdi-logout</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Выйти</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list>
    </v-navigation-drawer>
  </div>
</template>
<script>
import RoleService from "@/api/RoleService";

export default {
  name: 'Navigation',
  props: [],
  data: () => ({
    drawer: null,
    miniVariant: false,
    access: {},
  }),
  mounted() {
    this.init();
  },
  methods: {
    init() {
      RoleService.access().then((res) => {
        if (res.data && res.data.access) {
          this.access = JSON.parse(res.data.access)
        } else {
          localStorage.removeItem('token');
          document.location.reload();
        }
      });
    },
    logout() {
      localStorage.removeItem('token');
      document.location.reload();
    }
  },
}
</script>

<style lang="scss">
.mobile-menu {
  display: none;
  margin-top: 10px;
  margin-left: 10px;

  @media (max-width: 1264px) {
    display: block;
  }
}

.desktop-menu {
  display: block;

  @media (max-width: 967px) {
    display: none;
  }
}

.drawer-mobile {
  max-height: 100dvh;
}
</style>
